/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * DatePicker header hook - for all calendar headers
 * - check arrow disabled
 * - handle arrow click
 *
 * @author Yakov Gushchin
 * @version 1.10.0
 * @since 1.10.0
 */

import moment, { unitOfTime } from 'moment';

import { IDatePickerHeaderProps } from '../../types/datePickerTypes';

interface IUseDatePickerHeaderSingle {
    period: IDatePickerHeaderProps['period'];
    maxDate: IDatePickerHeaderProps['maxDate'];
    minDate: IDatePickerHeaderProps['minDate'];
    periodChangeHandler: IDatePickerHeaderProps['periodChangeHandler'];
}

const useDatePickerHeader = (props: IUseDatePickerHeaderSingle) => {

    const {
        period,
        maxDate,
        minDate,
        periodChangeHandler,
    } = props;

    const isArrowDisabled = (selectDuration: unitOfTime.Base, type: 'increase' | 'decrease'): boolean => {
        return type === 'increase'
            ? !!maxDate && period.unix() >= maxDate.clone().startOf(selectDuration).unix()
            : !!minDate && period.unix() <= minDate.clone().endOf(selectDuration).unix()
    }

    const onArrowClick = (selectDuration: unitOfTime.Base, type: 'increase' | 'decrease'): void => {
        periodChangeHandler(type === 'increase'
            ? moment(period).add(1, selectDuration)
            : moment(period).subtract(1, selectDuration),
        );
    };

    return {
        isArrowDisabled,
        onArrowClick,
    }
};

export default useDatePickerHeader;
